module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('h2', [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  }), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_foreword"
    }
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_theshma"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("Sh’ma")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_introduction"
    }
  }, [_vm._v("Introduction—Introducing the "), _c('i', [_vm._v("Sh’ma")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('h4', [_c('span', {
    attrs: {
      "href": "#/html/10_part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A CALL TO LISTEN")])]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('table', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hear")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isra’el")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lord Our God")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lord Is One")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blessed Be His Glorious Name")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whose Kingdom Is Forever And Ever")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('h4', [_c('span', {
    attrs: {
      "href": "#/html/17_part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A CALL TO LOVE")])]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('table', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("And You Shall Love The Lord Your God")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With All Your Heart")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With All Your Being")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With All Your Resources")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('h4', [_c('span', {
    attrs: {
      "href": "#/html/22_part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A CALL TO DO")])]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('table', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love Your Neighbor As Yourself")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Your Heart")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teach Them Carefully To Your Children")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talk About Them")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/27_chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/27_chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tie Them As A Sign")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/28_chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/28_chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Write Them")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/29_chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/29_chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Look, Remember, And Obey")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/30_chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/30_chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bless The Lord Who Is Blessed")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/31_finalthoughts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Thoughts—“Do You Love Me?”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/32_glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary of Hebrew Terms and Concepts")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/33_bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71a20abc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_contents.vue
// module id = 78
// module chunks = 0